import _ from 'lodash'

import type { CurrentSearchLike } from '@/misc/types'
import { ConditionGroup, CriterionCondition } from '@/store/modules/searches/types'
import { KeywordParams, KeywordSearch } from '@/text-processing/types'

// We construct a fake search for every keyword that is in the current search
export function getAdditionnalKeywordSearches(keywordParam: KeywordParams): KeywordSearch[] {
  const additionnalKeywordSearches = []
  if (keywordParam) {
    let keywordType: string
    let documentType: string | null
    for (const [key, value] of Object.entries(keywordParam)) {
      const keywords = value
      keywordType = key === 'kw' ? 'presentContent' : key.replace('kw-', 'presentContent__')
      documentType = key === 'kw' ? null : key.replace('kw-', '')
      keywords.forEach((keyword, idx) => {
        additionnalKeywordSearches.push({
          documentType,
          value: keyword,
          search: {
            id: `kw-${keywordType}-${idx}`,
            criteriaGroups: [{
              reference: 'tmp',
              criteriaList: [{ type: keywordType, value: keyword }]
            }]
          }
        })
      })
    }
  }
  return additionnalKeywordSearches
}

// Mirrors the ids/values/types derived by getKeywordList/getAdditionnalKeywordSearches from the
// search in progress, so the orphan-present-contents route is queried for exactly the same keywords
// the "mots-clés" section ends up displaying.
export function buildKeywordSearchParams(currentSearch: CurrentSearchLike): { ids: string[], values: string[], types: string[] } {
  const additionnalKeywordSearches = getAdditionnalKeywordSearches(getKeywordList(currentSearch?.criteriaGroups ?? []))

  return {
    ids: additionnalKeywordSearches.map((keyword) => keyword.search.id),
    values: additionnalKeywordSearches.map((keyword) => keyword.value),
    types: additionnalKeywordSearches.map((keyword) => keyword.search.criteriaGroups[0].criteriaList[0].type),
  }
}

export function getKeywordList(conditionGroups: ConditionGroup[]): KeywordParams {
  const keywordList: KeywordParams = {}
  let presentContentConditions: CriterionCondition[] = []
  conditionGroups.forEach((conditionGroup) => {
    const currentPresentContentCriteria = conditionGroup.criteriaList.filter((f) => f.type.startsWith('presentContent'))
    if (currentPresentContentCriteria) {
      presentContentConditions = _.uniq(presentContentConditions.concat(currentPresentContentCriteria))
    }
  })

  presentContentConditions.forEach((condition) => {
    const typeTokens = condition.type.split('__')
    const docType = typeTokens.length > 1 ? typeTokens[1] : null
    const key = docType !== null ? `kw-${docType}` : 'kw'

    if (!keywordList[key]) {
      keywordList[key] = []
    }
    keywordList[key].push(condition.value)
  })

  return keywordList
}
